import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// PWA: register service worker (production only)
if (
  "serviceWorker" in navigator &&
  window.location.protocol === "https:" &&
  process.env.NODE_ENV === "production"
) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        // Reload the tab once the NEW SW actually takes control — but ONLY
        // after the user opts in via the toast (which posts SKIP_WAITING).
        let reloaded = false;
        navigator.serviceWorker.addEventListener("controllerchange", () => {
          if (reloaded) return;
          reloaded = true;
          window.location.reload();
        });

        // Ask the app to prompt the user. `apply()` triggers activation
        // of the waiting worker → controllerchange → reload above.
        const promptUpdate = (worker) => {
          if (!worker) return;
          window.dispatchEvent(
            new CustomEvent("glitch-sw-update", {
              detail: { apply: () => worker.postMessage("SKIP_WAITING") },
            })
          );
        };

        // A previous visit installed a new SW but the user never applied it.
        if (reg.waiting && navigator.serviceWorker.controller) {
          promptUpdate(reg.waiting);
        }

        // A brand-new SW just finished installing during this session.
        reg.addEventListener("updatefound", () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener("statechange", () => {
            if (nw.state === "installed" && navigator.serviceWorker.controller) {
              promptUpdate(nw);
            }
          });
        });
      })
      .catch(() => {
        /* silent */
      });
  });
}
